export default {"src":"/login-app/[GIT_HASH]/_next/static/media/assignment_turned_in.326e03b7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};